import React, { FunctionComponent } from 'react';
import { toPairs, reduce } from 'ramda';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import CustomPopover from '../../../../components/CustomPopover';
import AttributePopupBody from '../../components/AttributePopupBody';
import Icon from '../../../../components/Icon';
import { IQuestion } from '../../../../common/models/question/IQuestion';
import { IAttribute } from '../../../../common/models/attribute/IAttribute';
import { IAppState } from '../../../../common/models/store/IAppState';
import { getAttributeColors } from '../../../../common/helpers/colorHelper';
import styles from './styles.module.scss';

interface IProps {
  attributes: IAttribute[];
  selectedQuestions: IQuestion[];
}

const AttributesCounter: FunctionComponent<IProps> = ({ attributes, selectedQuestions }) => {
  const defaultCounters = reduce((acc, elem) => ({ ...acc, [elem.name]: 0 }), {}, attributes);
  const attributeCounters = reduce((acc, { subAttribute }) => (subAttribute
    ? { ...acc, [subAttribute.attribute.name]: acc[subAttribute.attribute.name] + 1 }
    : acc), defaultCounters as Record<string, number>, selectedQuestions);

  const Attribute = ({ attribute, count }: { attribute: string; count: number }) => (
    <div>
      <div className={styles.attributeTitle}>
        <span className="t-14 mr-2">
          {attribute === 'total'
            ? <FormattedMessage id="total" defaultMessage="Total" />
            : attribute}
        </span>
        {attribute !== 'total' && <Icon className="trigger-arrow" icon="chevronDown" />}
      </div>
      <div className={styles.countText}>
        {attribute !== 'total' && (
          <div
            className={styles.attributeSquare}
            style={{ backgroundColor: getAttributeColors(attribute).color }}
          />
        )}
        <FormattedMessage
          id={count === 1 ? 'ratingScale.question' : 'ratingScale.questions'}
          defaultMessage="{value} question(s)"
          values={{ value: count }}
        />
      </div>
    </div>
  );

  return (
    <div className={styles.attributesContainer}>
      <Attribute attribute="total" count={selectedQuestions.length} />
      {toPairs(attributeCounters).map(([attribute, count]) => (
        <CustomPopover
          key={attribute}
          placement="top"
          rootClose
          trigger={<Attribute attribute={attribute} count={count} />}
          showArrow
        >
          <AttributePopupBody selectedQuestions={selectedQuestions} attributes={attributes} attribute={attribute} />
        </CustomPopover>
      ))}
    </div>
  );
};

const mapStateToProps = ({
  surveyBuilder: { attributes }
}: IAppState) => ({ attributes });

export default connect(mapStateToProps)(AttributesCounter);
